import Vue from 'vue'
import Router from 'vue-router'
import Study from '@/page/Study'
import Meeting from '@/page/Meeting'
import MeetingView from '@/page/MeetingView'
import Article from '@/page/Article'
import ArticleView from '@/page/ArticleView'
import News from '@/page/News'
import Classroom from '@/page/Classroom'
import Service from '@/page/Service'
import FAQ from '@/page/FAQ'
import FAQView from '@/page/FAQView'
import About from '@/page/About'
import Product from '@/page/Product'
import ProductView from '@/page/ProductView'

Vue.use(Router)

export default new Router({
  base: '/shixing/',
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      redirect: '/study/meeting'
    },
    {
      path: '/index.html',
      redirect: '/study/meeting'
    },
    {
      path: '/study',
      name: 'Study',
      component: Study,
      meta: {
        title: '' // '学习工具'
      },
      children: [
        {
          path: 'meeting',
          name: 'Meeting',
          component: Meeting,
          meta: {
            title: '' // '会议通知'
          }
        },
        {
          path: 'article',
          name: 'Article',
          component: Article,
          meta: {
            title: '' // '学术文章'
          }
        },
        {
          path: 'news',
          name: 'News',
          component: News,
          meta: {
            title: '' // '进修资讯'
          }
        },
        {
          path: 'classroom',
          name: 'Classroom',
          component: Classroom,
          meta: {
            title: '' // '超人课堂'
          }
        }
      ]
    },
    {
      path: '/study/meeting/:id',
      name: 'MeetingView',
      component: MeetingView,
      meta: {
        title: '会议详情',
        showBack: true,
        // showShare: true,
        hideTabbar: true
      }
    },
    {
      path: '/study/article/:type/:id',
      name: 'ArticleView',
      component: ArticleView,
      meta: {
        title: '文章详情',
        showBack: true,
        hideTabbar: true
      }
    },
    {
      path: '/service',
      name: 'Service',
      component: Service,
      meta: {
        title: '延伸服务',
        hideHeader: true
      }
    },
    {
      path: '/service/faq',
      name: 'FAQ',
      component: FAQ,
      meta: {
        title: '常见问题',
        showBack: true,
        hideTabbar: true
      }
    },
    {
      path: '/service/faq/:id',
      name: 'FAQView',
      component: FAQView,
      meta: {
        title: '常见问题',
        showBack: true,
        hideTabbar: true
      }
    },
    {
      path: '/service/about',
      name: 'About',
      component: About,
      meta: {
        title: '关于我们',
        showBack: true,
        hideTabbar: true
      }
    },
    {
      path: '/product',
      name: 'Product',
      component: Product,
      meta: {
        title: '诊疗产品'
      }
    },
    {
      path: '/product/:id',
      name: 'ProductView',
      component: ProductView,
      meta: {
        title: '产品信息',
        showBack: true,
        hideTabbar: true
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js